import { JobRecord, MonthlyKeyedCounts } from './types';

// Generic function to group and count records by period and key (e.g., month & location/state/type)
export function groupByPeriodAndKey<T extends JobRecord>(
  records: T[],
  getPeriod: (record: T) => string,
  getKey: (record: T) => string
): MonthlyKeyedCounts {
  const result: MonthlyKeyedCounts = {};
  records.forEach((record) => {
    const period = getPeriod(record);
    const key = getKey(record);
    if (!result[period]) result[period] = {};
    result[period][key] = (result[period][key] || 0) + 1;
  });
  return result;
}

// Generic function to group and count records by a single key
export function groupByKey<T>(records: T[], getKey: (record: T) => string): Record<string, number> {
  const result: Record<string, number> = {};
  records.forEach((record) => {
    const key = getKey(record);
    result[key] = (result[key] || 0) + 1;
  });
  return result;
}
